// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".author~.author[data-v-2e0c0676]:before{content:\", \"}.text-page p.lead[data-v-2e0c0676]{margin-bottom:2rem}.text-page p.lead.color-black[data-v-2e0c0676]{color:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
